import React from 'react';
import { FormControl } from '@material-ui/core';

const SelectFormControl = ({ children, ...rest }) => {
  return <FormControl {...rest}>{children}</FormControl>;
};

export default SelectFormControl;
